import { render, staticRenderFns } from "./EntranceAgreement.vue?vue&type=template&id=0992abf4&"
import script from "./EntranceAgreement.vue?vue&type=script&lang=js&"
export * from "./EntranceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./EntranceAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports